<template>
    <div class="history-bg" style="padding: 0;height: 100%;width: 95%;position: relative;">
        <div class="" id="qxTwo" @mouseenter="clearDispatchTimer" @mouseleave="setDispatchTimer"
            style="height: 100%;width: 100%;"></div>
      <!--      <img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%8E%86%E5%8F%B2%E6%95%B0%E6%8D%AE%E8%83%8C%E6%99%AF%402x%20%281%29.png"
            style="width: 90px;height: 90px;position: absolute;top: 13px;right: 38px;" alt="">
        <div class="flexCol alit justc" style="width: 90px;height: 90px;position: absolute;top: 13px;right: 38px;">
            <div class="" style="width: 22px;font-size: 10px;color: #FFFFFF;"></div>
        </div> -->
		<div class="flex alit justc" style="position: absolute;top: 0px;right: 0px;width: 100%;height: 90px;margin-top: 10%;">
			<!-- <img src=""
				style="width: 90px;height: 90px;" alt=""> -->
			<div class="flexCol alit justc lswd" style="">
				<div class="" style="width: 22px;font-size: 10px;color: #FFFFFF;">历史AQI</div>
			</div>
		</div>

    </div>
</template>

<script>
import * as echarts from 'echarts'
import 'echarts-gl'
export default {
    data() {
        return {
            interVal: '',
            myChart: null,
            app: {
                currentIndex: -1,
            },
            dispatchTimer: null,
            dataLen: null
        }
    },
    mounted() {
        // this.requestData(500)
        this.init()
    },
    methods: {
        requestData(number, area, tulongNum, beforeMoney, afterMoney) {
            this.$request('center/newService1/farmLines?num=' + number + '&area=' + area + '&tulongNum=' + tulongNum + '&beforeMoney=' + beforeMoney + '&afterMoney=' + afterMoney).then(res => {
                if (this.myChart) {
                    clearInterval(this.dispatchTimer)
                    this.myChart.clear()
                }
                for (var i = 0; i < res.data.length; i++) {
                    if (res.data[i].type == 1) {
                        this.init(res.data[i].list);
                    }
                }

            })
        },
        init(pageData, type) {
            let that = this
            that.myChart = echarts.init(document.getElementById('qxTwo'))

            //随着屏幕大小调节图表
            window.addEventListener("resize", () => {
                that.myChart.resize();
            });

            const data = [
                { name: "<50", value: 90 },
                { name: "50-100", value: 120 },
                { name: "100-150", value: 135 },
                { name: ">120", value: 20 },
            ];
            const color2 = [
                "rgba(17, 141, 246, .2)",
                "rgba(247, 198, 124, .2)",
                "rgba(97, 216, 215, .2)",
                "rgba(215, 124, 111, .2)",
            ];
            const maxCircleData = data.map((item, index) => {
                return {
                    ...item,
                    itemStyle: {
                        color: color2[index],
                    },
                };
            });

            var option = {
                legend: {
                    show:true,
                    icon: 'circle',
                    top: 110,
                    itemWidth: 8,
                    itemHeight: 8,
                    // formatter: (name) => {
                    //     let obj = data.find(item => item.name === name)
                    //     const arr = [
                    //         `{iconName|}{offsetBlock|}{name|${name}}{value|${obj.value}}{unit|个}{percent|${obj.percent}}{unit|%}`
                    //     ];
                    //     return arr.join('')
                    // },
                    align: 'left',
                    
                    textStyle: {
                    	color: '#FFF',
                    	fontSize: 12,
                    	lineHeight: 14,
                    }
                },
                color: [
                    "rgba(17, 141, 246, 1)",
                    "rgba(247, 198, 124, 1)",
                    "rgba(97, 216, 215, 1)",
                    "rgba(215, 124, 111, 1)",
                ],
                series: [
                    {
                        type: "pie",
                        padAngle: 2,
                        radius: ["68%", "75%"],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                        },
                        labelLine: {
                            show: false,
                        },
                        data: data,
                        width: 110,height:125,
                        left: 'center',
                    }, {
                        type: "pie",
                        padAngle: 2,
                        radius: ["48%", "75%"],
                        label: {
                            show: false,
                        },
                        emphasis: {
                            disabled: true,
                        },
                        labelLine: {
                            show: false,
                            length: 6,
                            length2: 6,
                            minTurnAngle: 30,
                        },
                        itemStyle: {
                            color: "green",
                        },
                        data: maxCircleData,
                        width: 110,height:125,
                        left: 'center',
                    },

                ],
            }


            that.dataLen = option.series[0].data.length
            that.dispatchActions()

            that.myChart.setOption(option);
            this.interVal = setInterval(function () {
                that.myChart.clear()
                that.myChart.setOption(option);
            }, 240000)
            // 20000
        },
        dispatchActions() {
            let that = this
            that.dispatchTimer = setInterval(function () {
                // 取消之前高亮的图形
                that.myChart.dispatchAction({
                    type: 'downplay',
                    seriesIndex: 0,
                    dataIndex: that.app.currentIndex
                });
                that.app.currentIndex = (that.app.currentIndex + 1) % that.dataLen;
                //console.log(app.currentIndex);
                // 高亮当前图形
                that.myChart.dispatchAction({
                    type: 'highlight',
                    seriesIndex: 0,
                    dataIndex: that.app.currentIndex,
                });
                // 显示 tooltip
                that.myChart.dispatchAction({
                    type: 'showTip',
                    seriesIndex: 0,
                    dataIndex: that.app.currentIndex
                });
            }, 3000);
        },
        clearDispatchTimer() {
            clearInterval(this.dispatchTimer)
        },
        setDispatchTimer() {
            this.dispatchActions()
        },
    },
    destroyed() {
        clearInterval(this.interVal)
    },

}
</script>

<style>
.lswd {
		width: 110px;
		height: 110px;
		background-image: url('https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%8E%86%E5%8F%B2%E6%95%B0%E6%8D%AE%E8%83%8C%E6%99%AF%402x%20%281%29.png');
		background-size: 100% 100%;
	}
</style>